import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import HallSeatPlanListTable from './Components/HallSeatPlanListTable'

const HallSeatPlanList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Seatplan List</HeadingOne>
                    <AddItemBtn url="add-hall-seatplan" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HallSeatPlanListTable />
            </div>
        </PageBody>
    )
}

export default HallSeatPlanList
